import React from "react";
import "./technology-software.scss"
import Marquee from "react-fast-marquee";

const TechnologySoftware = React.forwardRef((props, ref) => {

  const technology = [
    { name: "Node", icon: "/technology-software-images/nodejs-logo.png" },
    { name: "React", icon: "/technology-software-images/react.png" },
    { name: "React Native", icon: "/technology-software-images/react-native.svg" },
    { name: "Html", icon: "/technology-software-images/html.png" },
    { name: "Css", icon: "/technology-software-images/css.png" },
    { name: "Sap", icon: "/technology-software-images/sap.png" }
  ]

  const software = [
    { name: "Figma", icon: "/technology-software-images/figma-logo.png" },
    { name: "GitHub", icon: "/technology-software-images/github-logo.png" },
    { name: "Postman", icon: "/technology-software-images/postman-logo.png" },
    { name: "MongoDB", icon: "/technology-software-images/db.svg" },
    { name: "DigitalOcean", icon: "/technology-software-images/digital-ocean.png" },
    { name: "Wix", icon: "/technology-software-images/wix.png" },
    { name: "WordPress", icon: "/technology-software-images/wordpress.png" },
    { name: "Shopify", icon: "/technology-software-images/shopify.png" },
    { name: "Jira", icon: "/technology-software-images/jira.svg" }
  ]

  return (
    <div ref={ref} className="technology-software-container">
      <span className="technology-heading">Our Expertise Technologies and software</span>
      <Marquee>
        {technology?.map((tech, index) => (
          <div key={index} className="technology-container">
            <img src={tech.icon} alt={tech.name} className="technology-container__img"></img>
            {tech.name}
          </div>
        ))}
      </Marquee>
      <Marquee>
        {software?.map((software, index) => (
          <div key={index} className="technology-container">
            <img src={software.icon} alt={software.name} className="technology-container__img"></img>
            {software.name}
          </div>
        ))}
      </Marquee>
    </div>
  )
});

export default TechnologySoftware;
